<template>
  <div>
    <div class="game strup" v-show="!reaction">
      <div class="shulte__body">


        <!-- ИНФОБЛОК -->
        <div class="train__info" v-if="active">
          <!--<div class="train__item" uk-tooltip="Ошибок сделано">
            <div class="train__ico train__ico&#45;&#45;2"></div>
            <small>Ошибок:</small>
            {{ errors }}
          </div>-->
          <div class="train__item" v-if="$route.params.isHomework" uk-tooltip="Выполнено упражнений">
            <div class="train__ico train__ico--4"></div>
            <small>Выполнено:</small>
            <div class="train__nowrap">{{ $route.params.total }} из {{ $route.params.qnt }}</div>
          </div>
          <div class="train__item" uk-tooltip="Времени прошло">
            <div class="train__ico train__ico--3"></div>
            <div>
              <small>Времени прошло:</small>
              <!--<br class="uk-visible@s">-->
              {{ timer.minutes }} мин. {{ timer.seconds }} сек.
            </div>
          </div>
        </div>

        <!-- ТЕЛО ТРЕНАЖЕРА -->
        <div class="strup__body">

          <div v-if="params.mode === 'words'">
            <div class="strup__words">
              <div class="strup__word" v-if="start_game && current_step" :style="`color:${current_step.color}`">{{ current_step.word }}</div>
            </div>
          </div>
          <div v-if="params.mode === 'table'">
            <div class="strup__table" v-if="start_game">
              <span v-for="w in ready_words" :key="w.id" :style="`color:${w.color}`">{{ w.word }}</span>
            </div>
            <div class="strup__link" v-if="start_game">
              <a href="#" @click.prevent="stopGame">Закончить чтение</a>
            </div>
          </div>
          <div class="strup__button" v-if="!start_game && !params.finish">
            <button class="uk-button uk-button-primary" @click="letStartGame()" v-if="!start_game">Начать!</button>
          </div>

        </div>

      </div>

      <!-- ФИНИШ -->
      <div v-if="params.finish">
        <h3>Отлично!</h3>
        <!--<p></p>-->
        <p class="scores">И ты зарабатываешь
          <strong>{{ scores }}</strong> {{ $root.getNoun(scores, 'балл', 'балла', 'баллов') }}!</p>
        <button class="uk-button uk-button-primary" @click="startGame" v-if="!checkFinishHomework()">Повторить!</button>
        <button class="uk-button uk-button-primary" @click="onStopTrainer" v-else>Закончить</button>
      </div>
      <a href="#" @click.prevent="onStopTrainer">Остановить</a>
    </div>

    <!-- РЕАКЦИИ -->
    <div class="wh-block wh-block--reaction" v-if="reaction">
      <div class="reaction">
        <!--<video loop muted preload="auto" autoplay>-->
        <video disableRemotePlayback preload="auto" autoplay @ended="stopReaction">
          <source type="video/mp4" :src="'/storage/app/media/reactions/' + reaction_file" id="mp4">
        </video>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { mix } from "./../mixin";
import { soundMix } from "../../../mixins/sound";
import axios from 'axios'

export default {
  name: "game",
  mixins: [
    mix, soundMix
  ],
  data() {
    return {
      /** NEW METHODS */
      colors: [
        '#ffff1f',
        '#0000ff',
        '#ffc0cb',
        '#000000',
        '#ff0000',
        '#00e600',
        '#8b00ff',
        '#ffa500',
        '#999999',
        '#964b00',
        '#42aaff',
      ],
      words: [
        'Желтый',
        'Синий',
        'Розовый',
        'Черный',
        'Красный',
        'Зеленый',
        'Фиолетовый',
        'Оранжевый',
        'Серый',
        'Коричневый',
        'Голубой'
      ],
      ready_words: [],
      steps: '',
      local_steps: 1,
      results: [],
      local_results: [],
      stat_id: '',
      current_step: '',
      step_key: '',
      user_answer: '',
      start_game: false,
      steps_end: false,
      /** OLD */
      cifs: '',
      shuffle: '',
      active: true,
      step: 0,
      errors: 0,
      nextCif: '',
      currentCif: '',
      reaction: false,
      scores: 0,
    }
  },
  computed: {
    ...mapState({
      params: state => state.train.strup_params
    }),
    finish() {
      return this.params.finish
    },
    user() {
      return this.$store.state.user;
    },
    success() {
      return this.user_answer === this.currentPosition;
    }
  },
  inject: ['http'],
  methods: {
    /** NEW METHODS */
    prepareWordsArray() {
      console.log('prepare words');
      let arr = [];
      let steps = this.params.steps;
      let colors = this.colors;
      let words = this.words;
      for (let i = 0; i < steps; i++) {
        let obj = {
          'word': _.sample(words),
          'color': _.sample(colors)
        };
        arr.push(obj);
      }
      this.ready_words = arr;
      console.log(arr);
    },

    async letStartGame() {
      this.params.finish = false;
      this.start_game = true;
      this.steps_end = false;
      this.prepareWordsArray();
      if (this.params.mode === 'words') {
        await this.countDown();
        this.startTimer();
        this.showSteps();
      } else {
        this.startTimer();
      }
    },

    showSteps() {
      console.log('show steps');
      let steps = this.ready_words;
      let speed = this.params.speed;

      let timer;
      let app = this;

      function reading(currentStep = 0) {
        app.current_step = '';
        //console.log(app.params.start, steps.length);
        if (currentStep >= steps.length || !app.params.start) {
          console.log('finish');
          //app.params.finish = true;
          //app.steps_end = true;
          app.stopGame();
          return;
        } else {
          app.current_step = steps[currentStep];
          app.step_key = (currentStep % 2 === 0) ? 'odd' : 'even';
          app.playBeeSound('cif2');
          currentStep++;
          timer = setTimeout(reading, (speed * 1000), currentStep);
        }
      }

      reading();
    },

    async countDown() {
      console.log('CountDown');
      let arr = [{
        'word': 'На старт!',
        'color': '#0080DA'
      },
        {
          'word': 'Внимание!',
          'color': '#0080DA'
        },
        {
          'word': 'Марш!',
          'color': '#0080DA'
        },];
      let app = this;

      function setStep(currentStep) {
        app.current_step = currentStep;
        app.step_key = 'ready';
        app.playBeeSound('cif1');
      }

      setStep(arr[0]);
      for (let i = 1; i < 3; i++) {
        await this.sleep(1000);
        console.log(arr[i]);
        setStep(arr[i]);
      }
      await this.sleep(1000);
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    checkAnswer(i) {
      if (this.steps_end && !this.params.finish) {
        this.user_answer = i;

        this.startReaction();

        if (this.success) {
          this.playBeeSound('yes1');
        } else {
          this.playBeeSound('no');
          this.errors++;
        }

        if (!this.params.show_reactions) {
          if (i === this.currentPosition) {
            console.log('Правильно!');
            swal('Правильно!', 'Дракоша найден!', 'success');
          } else {
            console.log('Неправильно!');
            swal('Не вышло!', 'Дракоша смог от тебя спрятаться! Попробуй еще разок!', 'error');
          }
        }

        let result = {
          position: this.currentPosition,
          user_answer: +this.user_answer,
          timer: this.timer
        };

        this.addScores();

        this.results.push(result);
        this.local_results.push(result);

        if (this.local_steps > 1 && this.stat_id) {
          this.updateStats();
        } else {
          this.makeStats();
        }
        this.params.finish = true;
      }
    },

    /** OLD */

    stopGame() {
      this.start_game = false;
      this.params.finish = true;
      this.steps_end = true;
      let result = {
        timer: this.timer
      };
      this.addScores();
      this.results.push(result);
      this.local_results.push(result);

      if (this.local_steps > 1 && this.stat_id) {
        this.updateStats();
      } else {
        this.makeStats();
      }
      //this.active = false;
      //this.$parent.commitVal(true, 'finish');
    },

    startGame() {
      this.scroll();
      this.local_steps++;
      this.user_answer = '';
      this.start_game = false;
      this.params.finish = false;
      this.step = 0;
      //this.errors = 0;
      this.active = true;
      this.steps_end = false;
    },
    addScores() {
      let sum = 0;
      let steps = +this.params.steps;

      if(steps <= 25){
        sum = 1;
      } else {
        sum = 2;
      }

      console.log(sum, steps);

      if (this.$route.params.isHomework) {
        sum = Math.ceil(sum * this.$store.state.hw_coefficient);
      }
      this.checkScoreStatus(sum);
      this.scores = sum;

      this.$store.commit('changeUserScores', sum);
      console.log('Баллов заработано', sum);
    },

    /** СОЗДАНИЕ И ОБНОВЛЕНИЕ СТАТИСТИКИ */
    async makeStats() {
      console.log("Make stats");
      if (this.user.role.code === 'student') {
        console.log('Бережно сохраняем статистику');

        let time = this.timer;
        let errors = this.errors;
        let train_params = this.params;
        let stats = {
          total: this.getTotalTime(this.local_results),
          results: this.results,
          time: time,
          errors: errors,
          count: this.local_steps,
          user_id: this.$store.state.user.id,
          trainer: this.$store.state.current_trainer.id,
          scores: this.scores,
          train_params: {
            speed: train_params.speed,
            steps: train_params.min_steps,
            mode: train_params.mode
          }
        }

        stats = this.checkHomework(stats);
        let data = {
          'stat': stats
        }
        console.log(stats);
        this.http.post('onSaveStats', data).then((res) => {
          this.stat_id = res.data.id;
          this.checkCoins(res.data);
        })

      } else {
        console.log('Учителей в статистику не заносим! Понятно?!');
      }
    },

    getTotalTime(arr) {
      return _.reduce(arr, function (sum, i) {
        return sum + i.timer.total_ms;
      }, 0);
    },

    async updateStats() {
      if (this.user.role.code === 'student') {
        console.log('Update stats');
        let time = this.getTotalTime(this.local_results);
        let stat_id = this.stat_id;
        let arr = {
          results: this.results,
          time: time,
          errors: this.errors,
          stat_id: stat_id,
          count: this.local_steps,
          scores: this.scores,
          isHomework: this.$route.params.isHomework ? true : false
        }
        let data = {
          'stat': arr
        }
        this.updateHomework();
        this.http.post('onUpdateStats', data).then((res) => {
          this.checkCoins(res.data);
        })
      }
    },

    /** РЕАКЦИИ */
    startReaction() {
      if (this.params.show_reactions) {
        let type = (this.user_answer === this.currentPosition ? 'react_plus' : 'react_minus');
        this.reaction_file = this.checkReaction(type);
        this.reaction = true;
      }
    },
    stopReaction() {
      this.reaction = false;
      let app = this;
      setTimeout(function () {
        app.scroll();
        $('#repeat-' + app.inkey).focus();
      }, 100);
    },
    scroll() {
      UIkit.scroll('.headline2').scrollTo('.game');
    }
  },
  mounted() {
    //this.prepareWordsArray();
    //this.startGame();
    this.params.finish = false;
  },
  beforeDestroy() {
    //this.makeStats();
    this.$parent.commitVal(false, 'start')
  }
}
</script>